import { api } from '../../services/api'

export const getVets = () => {
	return (dispatch) => {
		dispatch({ type: 'GET_VETS' })
		return api
			.get('/vets')
			.then((response) => {
				dispatch({ type: 'GET_VETS_SUCCESS', payload: response.data })
			})
			.catch(() => {
				dispatch({ type: 'GET_VETS_FAIL' })
			})
	}
}
